import { GRAPHQL_TYPENAMES } from 'modules/graphql/types';
import { ListReference } from 'modules/legacySegmentation/domain';
import { getLabelByMedium } from 'utils/messageMediums';

import { Cell } from './table/Cell';
import { TABLE_COLUMNS } from './constants';
import { PlaceholderText } from './PlaceholderText';

type ListReferenceMessageMediumCellProps = {
  listReference: ListReference;
  rowIndex: number;
};

export const testIds = {
  cell: 'segmentation-lrmc-cell',
  text: 'segmentation-lrmc-text',
};

export const ListReferenceMessageMediumCell = ({
  listReference: dependent,
  rowIndex,
}: ListReferenceMessageMediumCellProps) => (
  <Cell
    data-test={testIds.cell}
    columnId={TABLE_COLUMNS.MEDIUM}
    {...(rowIndex % 2 === 0 && { className: 'shadedRow' })}
  >
    {dependent.__typename === GRAPHQL_TYPENAMES.CAMPAIGN ? (
      <div data-test={testIds.text}>{getLabelByMedium(dependent.messageMedium)}</div>
    ) : (
      <PlaceholderText>N/A</PlaceholderText>
    )}
  </Cell>
);
